import React from "react";
import AppFieldSubtitleConfig from "./app_field_subtitle_config";

class AppFieldSubtitle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
       
        };
    }

    //Available properties
    propFontColor(){ return this.props.fontColor || AppFieldSubtitleConfig.fontColor.gray};
    propFontStyle(){ return this.props.fontStyle };
    propText(){ return this.props.text };

    componentDidMount() {   
    
    }

    render() {
        return (
            <small
                id="IDSubtitle"
                style={{
                    fontSize: "12px",
                    color: this.propFontColor() == AppFieldSubtitleConfig.fontColor.gray ? "#808ea8" : "",
                }}
                className={
                    `${this.propFontColor() == AppFieldSubtitleConfig.fontColor.gray ? "form_normal_subtitle_input " : "form_bold_subtitle_input"}`
                }
            >
                {this.propText()}
            </small>
        );
    }
}

export default AppFieldSubtitle;
